const TEMPLATE_PROJECT_NAME = 'Template';

/**
 * Synthesize the shape returned by `fetchSyncedDataWithHierarchy('Event', field.ID, ...)`
 * from pre-fetched template data, so leaf chart components can use a single aggregation
 * path regardless of source.
 *
 * @param {object|null|undefined} templateActivityData - The `templateData.data` blob from exportTemplateData.
 * @param {string} fieldId - EventField ID to filter results by.
 * @returns {{ records: object[], hierarchy: object, totalRespondents: number, totalDocs: number } | null}
 *          `null` when not in template mode — callers should fall back to Firestore.
 */
export const buildTemplateEventResult = (templateActivityData, fieldId) => {
    if (!templateActivityData || !fieldId) return null;

    const all = templateActivityData.outputs?.eventResults || [];
    const filtered = all.filter(r => r.FieldID === fieldId);

    const records = filtered.map(r => ({
        ...r,
        _projectName: TEMPLATE_PROJECT_NAME,
        _hierarchyPath: '0',
    }));

    const sessions = new Set(filtered.map(r => r.SessionID).filter(Boolean));
    const totalRespondents = sessions.size || records.length;

    const hierarchy = {
        [TEMPLATE_PROJECT_NAME]: {
            depth: 0,
            path: '0',
            totalDocs: records.length,
            totalResponses: records.length,
            totalRespondents,
        },
    };

    return {
        records,
        hierarchy,
        totalRespondents,
        totalDocs: records.length,
    };
};
